<template>
 <div class="goodListBox" >
	 <div class="goodListHead" >
		 <div class="headLeft" >
			 <img src="../../assets/img/icon/Arrowleft000.png" alt="">
		 </div>
		 <div class="centerSearch" >
			<van-search
				  v-model="value"
				  shape="round"
				  placeholder="搜索商品"
				/>
		 </div> 
		 <div class="headRight" @click="togglePermu" >
			<img v-if=" permutation == 'rect' " src="../../assets/img/icon/rectShow.png" alt="">
			<img v-if=" permutation ==  'vertical' " src="../../assets/img/icon/verticalShow.png" alt=""> 
		 </div>
		 </div>
		 <div class="listTools" >
            <div> <span>综合</span> </div>
			<div> <span>销量</span> </div>
			<div> <span>价格</span> <img src="../../assets/img/icon/higher.png" alt="">  </div>
			<div> <span>综合</span> <img src="../../assets/img/icon/filters.png" alt="">  </div>
		 </div>
		 <div  v-if=" permutation == 'vertical' " >
           <listOfItems></listOfItems>
		   <listOfItems></listOfItems>	
		 </div>
		<div  v-if=" permutation == 'rect' " >
           <verticalItemList></verticalItemList>
		    <verticalItemList></verticalItemList>
		</div>
	 </div>
  
</template>

<script>
import listOfItems from '../../components/listOfItems.vue';
import verticalItemList from '../../components/verticalItemList.vue';
export default {
  name: 'kindDetail',
  data() {
    return {
		value:'',
		permutation:"vertical"
    }
  },
  components: {
	  listOfItems,
	  verticalItemList
  },
  methods: {
     togglePermu(){
		 if(this.permutation == 'vertical' ){
			 this.permutation = 'rect'
		 }else{
			this.permutation = 'vertical' 
		 }
	 },
	goCommodityDetails(){
		this.$router.push('./goodsDetail') 
	}
  }
}
</script>
<style scoped lang='less'>
	.goodListBox{
		.goodListHead{
          display: flex;
		  justify-content: space-between;
		  background-color: #fff;
		  position: relative;
   		  padding: 0 30px;
          .headLeft{
              img{
				width: 20px;
				height: 36px;
				position: absolute;
				top: 50%;
				transform: translateY(-50%);
				}
			}
		  .centerSearch{
			width: 80%;
			height: 110px;
		   }		  
          .headRight{
              img{
				width: 34px;
				height: 30px;
				position: absolute;
				top: 50%;
				transform: translateY(-50%);
				right: 36px;
				}
			}
		}
	    .listTools{
			display: flex;
			justify-content: space-between;
			background-color: #fff;
			padding: 20px 0;
			div{
				width: 25%;
				text-align: center;
				span{
					font-size: 28px;
					color: #333333;
				}
				img{
					display: inline-block;
					width: 16px;
					height: 20px;
				}
			}
		}
	 
	}
	
</style>

